goog.provide("shadow.js.shim.module$src$svg$objects$3d_cube_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$3d_cube_svg");
shadow.js.shim.module$src$svg$objects$3d_cube_svg = shadow.js.nativeProvides["src/svg/objects/3d-cube.svg"] = shadow$bridge("src/svg/objects/3d-cube.svg");
module$shadow_js_shim_module$src$svg$objects$3d_cube_svg.default = shadow.js.shim.module$src$svg$objects$3d_cube_svg;
